import React, { useState, useEffect } from 'react'
import { MenuButton } from '@arnsbogroup/react-voicearchive'
import { Menu } from '@headlessui/react'
import { useIntl } from 'react-intl'
import messages from './messages'
import OrderHoldModal from './components/OrderHoldModal'
import NiceModal  from '@ebay/nice-modal-react'

const HoldOrder = ({ order, refetch, readOnly }) => {
  const [action, setAction] = useState(null)
  const { formatMessage } = useIntl()

  useEffect(() => {
    if (action) {
      NiceModal.show(OrderHoldModal, { refetch: refetch, orderId: order.uid, action: action })
    }
  }, [action]) 

  return (
    <>
      <Menu.Item state="negative" key='HoldOrder' disabled={readOnly}>
        {(props) => (
          <MenuButton disabled={readOnly} {...props} onClick={() => setAction('hold')}>
            <div className="flex justify-between items-center space-x-4">
              <span>{formatMessage(messages.hold)}</span>
            </div>
          </MenuButton>
        )}
      </Menu.Item>
      <Menu.Item state="negative" key='ResumeOrder' disabled={readOnly}>
        {(props) => (
          <MenuButton disabled={readOnly} {...props} onClick={() => setAction('resume')}>
            <div className="flex justify-between items-center space-x-4">
              <span>{formatMessage(messages.resume)}</span>
            </div>
          </MenuButton>
        )}
      </Menu.Item>
    </>
  )
}

export default HoldOrder
